
export const startLiveCaption = () => ({
  method: 'stt:start',
  params: {}
})
export const stopLiveCaption = () => ({
  method: 'stt:stop',
  params: {}
})